enum Currencies {
    AOA = 'AOA',
    CVE = 'CVE',
    BRL = 'BRL',
    XOF = 'XOF',
    MZN = 'MZN',
    EUR = 'EUR',
    STN = 'STN',
    USD = 'USD',
    MOP = 'MOP',
}

export default Currencies
